import styles from "./MultiTab.module.css";

const Tab = ({ title, code, icon, activeTab, handleTabChange, type = 1 }) => {
    switch (type) {
        case 1:
            return (
                <button
                    onClick={() => handleTabChange(code ? code : title)}
                    className={`${activeTab === title || activeTab === code ? 'border-gray-300' : 'border-gray-100'} flex gap-2 items-center border-solid border-b-2 px-4 pb-2 transition-all duration-200 ease-in-out`}
                >
                    <div>{icon}</div>
                    <span>{title}</span>
                </button>
            )
        case 2:
            return (
                <button
                    onClick={() => handleTabChange(code ? code : title)}
                    className={`${activeTab === title || activeTab === code ? 'bg-blue-500 text-white' : ''} flex gap-2 items-center p-3 rounded-3xl transition-all duration-200 ease-in-out`}
                >
                    <div>{icon}</div>
                    <span>{title}</span>
                </button>
            )
        case 3:
            return (
                <div
                    onClick={() => handleTabChange(code ? code : title)}
                    className={`${activeTab === title || activeTab === code ? 'bg-blue-100 text-blue-600' : ''} cursor-pointer flex gap-2 items-center p-2 rounded-xl transition-all duration-200 ease-in-out`}
                >
                    <div>{icon}</div>
                    <span>{title}</span>
                </div>
            )
        case 4:
            return (
                <button
                    onClick={() => handleTabChange(code ? code : title)}
                    className={activeTab === title || activeTab === code ? styles.selected : ""}
                >
                    {title}
                </button>
            )
    }
};

export default Tab;